import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "types";

const getAdminPriceState = (state:RootState) => state.AdminPriceState

export const selectAdminPriceData = createSelector(
    [getAdminPriceState],
    (AdminPriceState)=>AdminPriceState?.priceData || []
)


export const selectAdminPriceLoad = createSelector(
    [getAdminPriceState],
    (AdminPriceState)=>AdminPriceState?.loading 
)